export default __webpack_public_path__ + "static/media/1938.07db9845.png";